/* BRINUTI – a színváltó kollekcióban választott változat átvétele a
   termékoldalon.

   A kollekciós kártya linkje ?valtozat=<név> paramétert kap (a Teeinblue
   clipart-opció neve). Itt megvárjuk, amíg a Teeinblue kirajzolta az első
   clipart mezőt ÉS a mockup nyomtatási területét is, és csak utána kattintunk
   (egyszer) az azonos nevű opcióra — így a vásárló azt a borítót látja, amit
   a kártyán kiválasztott, nem az alapot.

   Miért kell a mockupra is várni: ha a mező már ott van, de a galéria még
   nem, a Teeinblue a kattintásra a még nem létező előnézetet próbálja
   frissíteni, és hibát dob (getComputedStyle … not of type 'Element').

   Paraméter nélkül semmit nem csinál. 20 másodperc után feladja. */
(function () {
  var nev = new URLSearchParams(location.search).get('valtozat');
  if (!nev) return;

  var kesz = false;
  var hatarido = Date.now() + 20000;

  /* A változat egy clipart-mezőben (minta) vagy egy sablon-mezőben (a
     naplók egy részénél a szín egész sablont vált) lehet — mindkettőben
     keresünk. */
  function cimke() {
    var cimkek = document.querySelectorAll('.tee-field--clipart label, .tee-field--template label');
    if (!document.querySelector('.tee-field--clipart, .tee-field--template')) return null;
    for (var i = 0; i < cimkek.length; i++) {
      var kep = cimkek[i].querySelector('img');
      if ((kep && kep.alt === nev) || (cimkek[i].innerText || '').trim() === nev ||
          cimkek[i].getAttribute('data-title') === nev) return cimkek[i];
    }
    if (!cimkek.length) return null;
    /* Ha még nincs meg, adunk 3 mp-et a többi mezőnek is, hogy kirajzolódjon;
       utána false: van mező, de ilyen nevű opció nincs. */
    elsoMezo = elsoMezo || Date.now();
    return Date.now() - elsoMezo < 3000 ? null : false;
  }
  var elsoMezo = 0;

  function probal() {
    if (kesz) return true;
    if (Date.now() > hatarido) return (kesz = true);
    if (!document.querySelector('.tee-mockup-item .tee-printarea--printarea')) return false;
    var c = cimke();
    if (c === null) return false;
    kesz = true;
    if (c === false) return true;
    var input = c.getAttribute('for') && document.getElementById(c.getAttribute('for'));
    if (input && input.checked) return true;
    /* Egy lélegzetnyi szünet, hogy a Teeinblue befejezze a saját első rajzolását. */
    setTimeout(function () { c.click(); }, 400);
    return true;
  }

  if (probal()) return;
  var figyelo = new MutationObserver(function () { if (probal()) leall(); });
  figyelo.observe(document.documentElement, { childList: true, subtree: true });
  var ora = setInterval(function () { if (probal()) leall(); }, 500);
  function leall() { figyelo.disconnect(); clearInterval(ora); }
  setTimeout(leall, 20000);
})();
